
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 56 55.6"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M47.1 54.8c-5.8.8-9.6.8-18.2.8s-14.8.1-19.9-.7-7.1-3.8-7.8-7.6S0 36.8 0 27.9.2 14.4 1.1 8.8s4.2-7.4 8-7.8a164.4 164.4 0 0119.2-1 148.2 148.2 0 0118.8 1.1c4.9.7 7.1 3 7.8 8s1 8.2 1 18-.4 17.1-1 20.1-2.1 6.8-7.8 7.6z","fill":"red"}}),_c('path',{attrs:{"d":"M41.2 41.6a113.8 113.8 0 01-12.6.4 132.2 132.2 0 01-13.8-.4c-3.5-.4-4.9-1.9-5.4-3.8a45.5 45.5 0 01-.8-9.9 43.2 43.2 0 01.7-9.7c.7-2.9 2.9-3.8 5.6-4.1s7.6-.4 13.3-.4 9.6.2 13 .5 4.9 1.5 5.5 4.1.6 4.1.6 9.2a46.3 46.3 0 01-.6 10.2c-.4 1.5-1.5 3.5-5.5 3.9z","fill":"#fff"}}),_c('path',{attrs:{"fill":"red","d":"M23.1 22.1v11.5l9.8-5.6-9.8-5.9z"}})])
          )
        }
      }
    